import React, { Component } from 'react';
import { Button, Col, Row, Spin, PageHeader, Layout, message, Empty, Tooltip } from 'antd'
import axios from 'axios';
import { ArrowRightOutlined, EyeOutlined } from "@ant-design/icons";
//Componentes
import { CardCuentaSaldo } from "../../Widgets/Cards"
import ModalTransaccionesDetalle from './Transacciones/ModalTransaccionesDetalle';
import '../../../Styles/Modules/Dashboard/dashboard.css';
import '../../../Styles/Modules/Finanzas/Dashboard.css';

const { Content, } = Layout;
const moment = require('moment')

/**
 * @const TIPOS_TRANSACCION
 * @description Etiqueta y color de cada tipo de transaccion (1 ingreso, 2 egreso, 3 traspaso)
 */
const TIPOS_TRANSACCION = {
    1: { label: 'Ingreso', className: 'fin-tag-ingreso', signo: '+' },
    2: { label: 'Egreso', className: 'fin-tag-egreso', signo: '-' },
    3: { label: 'Traspaso', className: 'fin-tag-traspaso', signo: '' },
}

/**
 *
 *
 * @export
 * @class Dashboard
 * @extends {Component}
 * @description Vista del Dashboard de Finanzas
 */
export default class DashboardFinanzas extends Component {

    constructor(props) {
        super(props)
        this.state = {
            loading: false,
            loading_trans: false,
            cuentas: [],
            transacciones: [],
            currentPage: 0,
            itemCount: 0,
            perPage: 0,
            pageCount: 0,
            saldo_total: 0
        }
    }

    componentDidMount() {
        //Mostrar input superior de busqueda
        //Para acceder al valor del input = this.props.search
        this.props.updateFilterSearch(false);
        axios.defaults.headers.common['Authorization'] = sessionStorage.getItem('token');
        this.getCuentas();
        this.getTransacciones();

    }


    /**
     *
     *
     * @memberof DashboardFinanzas
     * @description Obtiene la lista de cuentas disponibles
     */
    getCuentas = () => {
        this.setState({ loading: true })
        axios.get('/cuentas/list', {
            params: {
                page: 1,
                limit: 100,
            }
        }).then(response => {
            const cuentas = response.data.data.itemsList;

            let saldo_total = 0;

            cuentas.forEach(registro => {
                saldo_total += parseFloat(registro.saldo) || 0;
            })

            this.setState({
                saldo_total,
                cuentas: cuentas,
            })
        }).catch(error => {
            console.log(error)
            message.error('Error al traer la información')
        }).finally(() => this.setState({ loading: false }))
    }

    /**
    *
    *
    * @memberof DashboardFinanzas
    * @description Obtiene la lista las ultimas transacciones
    * @param values pagina
    */
    getTransacciones = (page = 1) => {
        this.setState({ loading_trans: true })
        axios.post('/transacciones/list', {
            page: page,
            limit: 10,
        })
            .then(res => {
                const data = res.data.data
                this.setState({
                    transacciones: data.itemsList,
                    currentPage: data.currentPage,
                    itemCount: data.itemCount,
                    perPage: data.perPage,
                    pageCount: data.pageCount
                })
            })
            .catch(res => {
                console.log("error", res);
                message.error('No se pudieron cargar las transacciones')
            })
            .finally(() => this.setState({ loading_trans: false }))
    }

    /**
     *
     * @memberof DashboardFinanzas
     * @description Renderiza el monto de la transaccion con el color y el signo de su tipo
     */
    renderMonto = (tipo, monto) => {
        const config = TIPOS_TRANSACCION[tipo] || TIPOS_TRANSACCION[3];
        return <span className={`fin-trans-monto ${config.className}`}>
            {config.signo} $ {(Number(monto) || 0).toMoney(true)} <span className="fin-trans-moneda">mxn</span>
        </span>
    }

    /**
     *
     * @memberof DashboardFinanzas
     * @description Renglon de una transaccion dentro de la tabla de ultimos movimientos
     */
    renderTransaccion = (item) => {
        const config = TIPOS_TRANSACCION[item.tipo] || TIPOS_TRANSACCION[3];

        return <div className="fin-trans-row" key={item._id}>
            <span className="fin-trans-fecha">{moment(item.fecha).format('DD MMM YYYY')}</span>
            <span className="fin-trans-concepto" title={item.concepto}>{item.concepto}</span>
            <span className="fin-trans-cuenta" title={item.cuenta_id?.nombre}>{item.cuenta_id?.nombre || 'Sin cuenta'}</span>
            <span className="fin-trans-rubro" title={item.rubro_id?.nombre}>{item.rubro_id?.nombre || 'Sin rubro'}</span>
            <span className={`fin-tag ${config.className}`}>{config.label}</span>
            {this.renderMonto(item.tipo, item.monto)}
            <Tooltip title="Ver detalle">
                <Button
                    className="fin-trans-btn"
                    icon={<EyeOutlined />}
                    onClick={() => this.setState({ modalTransacDetalleVisible: true, id: item._id })}
                />
            </Tooltip>
        </div>
    }

    render() {

        const { cuentas, saldo_total, transacciones } = this.state;

        /** Mes en curso con la primera letra en mayuscula, moment lo regresa en minusculas */
        const mes = moment().format('MMMM [de] YYYY');
        const periodo = mes.charAt(0).toUpperCase() + mes.slice(1);

        return (
            <>
                <Spin spinning={this.state.loading}>
                    <PageHeader
                        className="site-page-header custom-page-header"
                        title={<span className="ant-page-header-heading-title">
                            Finanzas <span className="dash-page-subtitle">· Saldos y movimientos</span>
                        </span>}
                    />
                    <Content className="admin-content content-bg dash-content">

                        {/* Cuentas */}
                        <div className="dash-section-head">
                            <span className="dash-section-bar" style={{ background: '#2D348C' }} />
                            <div>
                                <span className="dash-section-title">Cuentas</span>
                                <span className="dash-section-sub">Distribución del efectivo disponible</span>
                            </div>
                            <span className="dash-section-rule" />
                            <Button
                                className="dash-section-link"
                                onClick={() => this.props.history.push('/admin/cuentas')}
                            >
                                Ver cuentas <ArrowRightOutlined />
                            </Button>
                        </div>
                        <Row gutter={[16, 16]}>
                            {
                                cuentas.length > 0 ? cuentas.map(cuenta => (
                                    <Col xxl={6} xl={8} lg={8} md={12} sm={12} xs={24} key={cuenta._id}>
                                        <CardCuentaSaldo cuenta={cuenta} total={saldo_total} />
                                    </Col>
                                )) : <Col span={24}>
                                    <div className="dash-card fin-placeholder">
                                        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Sin cuentas registradas" />
                                    </div>
                                </Col>
                            }
                        </Row>

                        {/* Ultimas transacciones */}
                        <div className="dash-section-head">
                            <span className="dash-section-bar" style={{ background: '#12A594' }} />
                            <div>
                                <span className="dash-section-title">Últimas transacciones</span>
                                <span className="dash-section-sub">Movimientos más recientes de todas las cuentas</span>
                            </div>
                            <span className="dash-section-rule" />
                            <Button
                                className="dash-section-link"
                                onClick={() => this.props.history.push('/admin/finanzas/transacciones')}
                            >
                                Ver todas <ArrowRightOutlined />
                            </Button>
                        </div>
                        <Spin spinning={this.state.loading_trans}>
                            <div className="dash-card fin-trans">
                                <div className="fin-trans-head">
                                    <span>Fecha</span>
                                    <span>Concepto</span>
                                    <span>Cuenta</span>
                                    <span>Rubro</span>
                                    <span>Tipo</span>
                                    <span className="fin-trans-head-monto">Monto</span>
                                    <span />
                                </div>
                                {
                                    transacciones.length > 0
                                        ? transacciones.map(item => this.renderTransaccion(item))
                                        : <div className="fin-placeholder">
                                            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Sin transacciones" />
                                        </div>
                                }
                            </div>
                        </Spin>

                    </Content>

                    <ModalTransaccionesDetalle
                        visible={this.state.modalTransacDetalleVisible}
                        onClose={() => this.setState({
                            modalTransacDetalleVisible: false,
                            id: null
                        })}
                        id={this.state.id}
                    />
                </Spin>
            </>
        )
    }
}
